import React from 'react';
import PropTypes from 'prop-types';

const Play = ({ className, onClick }) => {
    return (
        <svg
            className={className}
            onClick={onClick}
            width="78"
            height="78"
            viewBox="0 0 78 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_dd)">
                <path
                    d="M15 32C15 18.7452 25.7452 8 39 8C52.2548 8 63 18.7452 63 32C63 45.2548 52.2548 56 39 56C25.7452 56 15 45.2548 15 32Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M39 40C43.4183 40 47 36.4183 47 32C47 27.5817 43.4183 24 39 24C34.5817 24 31 27.5817 31 32C31 36.4183 34.5817 40 39 40ZM39 42C44.5228 42 49 37.5228 49 32C49 26.4772 44.5228 22 39 22C33.4772 22 29 26.4772 29 32C29 37.5228 33.4772 42 39 42Z"
                    fill="#2F3037"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35 28.8042C35 27.2334 36.7279 26.2757 38.06 27.1083L43.1732 30.304C44.4265 31.0873 44.4265 32.9127 43.1732 33.696L38.06 36.8917C36.7279 37.7243 35 36.7666 35 35.1958V28.8042ZM42.1132 32L37 28.8042V35.1958L42.1132 32Z"
                    fill="#2F3037"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dd"
                    x="0"
                    y="0"
                    width="78"
                    height="78"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="7" />
                    <feGaussianBlur stdDeviation="7.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    />
                    <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

Play.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};

Play.defaultProps = {
    className: '',
    onClick: () => null,
};

export default Play;
